import { GuestController } from './guest.controller'
import { EntryController } from './pages/entry/entry.controller'
import { HomeController } from './pages/home/home.controller'
import { AssetPackController } from './pages/asset-pack/asset-pack.controller'
import { AssetPackItemsViewController } from './pages/asset-pack-items-view/asset-pack-items-view.controller'

/* @ngInject */
function routes ($stateProvider, $urlRouterProvider) {
  $urlRouterProvider.rule(function ($injector, $location) {
    const path = $location.path()

    // Add slash to the end of the url
    if (/^\/guest\/assetPack\/\d+$/i.test(path)) {
      return `${path}/`
    }
  })

  /**
   * When the state url has the company parameter, the InitializerService will change the company.
   * Obtaining the company's features and addons makes the route wait for the company change.
   */
  const awaitCompanyFeaturesAndAddons = ['$rootScope', ($rootScope) => $rootScope.getCompanyFeaturesAndAddons()]

  $stateProvider
    .state('guest', {
      url: '/guest',
      views: {
        '': {
          templateUrl: '/guest/guest.html?$$REVISION$$',
          controller: GuestController
        }
      }
    })
    .state('guest.login', {
      parent: 'guest',
      public: true,
      url: '/login?email&password&next&SSOAccess',
      reloadOnSearch: false,
      views: {
        'entry@guest': {
          templateUrl: '/guest/pages/entry/entry.html?$$REVISION$$',
          controller: EntryController
        }
      },
      data: {
        type: 'LOGIN'
      }
    })
    .state('guest.resendPassword', {
      parent: 'guest',
      public: true,
      url: '/resendPassword?next&email',
      views: {
        'entry@guest': {
          templateUrl: '/guest/pages/entry/entry.html?$$REVISION$$',
          controller: EntryController
        }
      },
      data: {
        type: 'RESEND_PASSWORD'
      }
    })
    .state('guest.home', {
      parent: 'guest',
      url: '/home?selectedTab',
      views: {
        'home@guest': {
          templateUrl: '/guest/pages/home/home.html?$$REVISION$$',
          controller: HomeController
        }
      }
    })
    .state('guest.briefingSummary', {
      parent: 'guest',
      url: '/briefing/:briefingId/summary?company',
      resolve: {
        awaitCompanyFeaturesAndAddons
      },
      views: {
        'entry@guest': {
          templateUrl: '/guest/pages/entry/entry.html?$$REVISION$$',
          controller: EntryController
        }
      },
      data: {
        type: 'BRIEFING_SUMMARY'
      }
    })
    .state('guest.approvalSummary', {
      parent: 'guest',
      url: '/approval/:approvalId/summary?company',
      resolve: {
        awaitCompanyFeaturesAndAddons
      },
      views: {
        'entry@guest': {
          templateUrl: '/guest/pages/entry/entry.html?$$REVISION$$',
          controller: EntryController
        }
      },
      data: {
        type: 'APPROVAL_SUMMARY'
      }
    })

    .state('assetPack', {
      url: '/guest/assetPack/:assetPackId',
      views: {
        '': {
          templateUrl: '/guest/pages/asset-pack/asset-pack.html?$$REVISION$$',
          controller: AssetPackController
        }
      }
    })
    .state('assetPack.assetPackSummary', {
      parent: 'assetPack',
      url: '/?company',
      resolve: {
        awaitCompanyFeaturesAndAddons
      },
      views: {
        'assetPackItemsView@assetPack': {
          templateUrl: '/guest/pages/asset-pack-items-view/asset-pack-items-view.html?$$REVISION$$',
          controller: AssetPackItemsViewController
        }
      },
      data: {
        type: 'ASSET_PACK_SUMMARY'
      }
    })
    .state('assetPack.assetPackFolder', {
      parent: 'assetPack',
      url: '/folders/:assetFolderId',
      views: {
        'assetPackItemsView@assetPack': {
          templateUrl: '/guest/pages/asset-pack-items-view/asset-pack-items-view.html?$$REVISION$$',
          controller: AssetPackItemsViewController
        }
      },
      data: {
        type: 'ASSET_PACK_SUMMARY'
      }
    })
    .state('assetPack.assetPackDownloadAll', {
      parent: 'assetPack',
      url: '/downloadAll',
      data: {
        type: 'ASSET_PACK_DOWNLOAD_ALL_SUMMARY'
      }
    })

  $urlRouterProvider.when('/guest/', '/guest')
  $urlRouterProvider.when('/guest/login/', '/guest/login')
}

export const guestRoutes = routes
